import React, { Component } from 'react'
import styles from './organisations.styles'
import injectSheet from 'react-jss'
import Container from '../../shared/container/container'
import Main from '../../shared/main/main'
import Paper from 'pobble-components/dist/paper'
import SectionTitle from '../../shared/section-title/section-title'
import OrganisationsList from './organisations-list/organisations-list.container'
import Spinner from 'pobble-components/dist/spinner'
import Button from 'pobble-components/dist/button'

class Organisations extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Container>
        <Main>
          <Paper className={classes.container}>
            <SectionTitle title="Organisations" />
            <Button href="/organisations/new" tall className={classes.add}>
              Create a new organisation
            </Button>
            {pending && <Spinner className={classes.spinner} />}
            {!pending && <OrganisationsList />}
          </Paper>
        </Main>
      </Container>
    )
  }
}

export default injectSheet(styles)(Organisations)
